import { Inject, Injectable } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';
import { SnackbarService } from '../../../../core/services/snackbar-psa.service';  // Import MatSnackBar
import { QueryService } from 'src/app/core/services/query.service';
import { CrudService } from 'src/app/core/services/crud.service';
import { NOTIFICATION_QUERY_SERVICE_INSTANCE } from './notification.config';
import { NOTIFICATION_ENDPOINT } from './notification.config';
import { NotificationDetail, Notifications } from './notification.model';
import { IPageEvent } from 'src/app/core/models/paginator.model';
import { Operazioni } from 'src/app/core/models/operazioni.model';
import { ApiFluxService } from 'src/app/core/services/api-flux.service';
import { CrudFluxService } from 'src/app/core/services/crud-flux.service';
import { map, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationFluxService extends CrudService<Notifications> {

  constructor(
    @Inject(NOTIFICATION_QUERY_SERVICE_INSTANCE) public readonly query: QueryService<Notifications>,
    public readonly apiService:ApiService,
    protected  override readonly snackbar : SnackbarService
    //@Inject(SnackbarService) protected override readonly snackbar: SnackbarService

  ) {
    super(NOTIFICATION_ENDPOINT, apiService, snackbar);
  }
  getAll<Notification>(parameter : IPageEvent,filter:string, searchData?:any){
    const filtro = filter.length>0 ? `&filter=${encodeURIComponent(filter)}` : ``
    const stringSearch = searchData ? `&search=${searchData}` : ``
    const sort = `&sortBy=${encodeURIComponent('createdAt:DESC')}`
    return this.apiService.get(NOTIFICATION_ENDPOINT+"?page="+parameter.pageIndex+"&limit="+parameter.pageSize+filtro+stringSearch+sort)
  }

  markAsRead(id:any){
    return this.apiService.post('notifications/'+id+'/mark-as-read', {})
  }

}
